import React from 'react';
import {
  chakra,
  Heading,
  Image,
} from '@chakra-ui/react';
import Post from 'shared/src/interfaces/Post.interface';

const ImageCustomerSection = ({ post }: { post: Post }) => {
  if (!post.imageFormVariables?.length) return null;
  return (
    <>
      <Heading fontSize="1.5em" pb="1em">Image</Heading>
      <chakra.figure maxW="50%" display="flex" flexDirection="column" alignItems="center">
        <Image src={post?.output.media?.[0]} maxH="50em" />
        <chakra.figcaption textAlign="center">Contact customer success to change image.</chakra.figcaption>
      </chakra.figure>
    </>
  );
};

export default ImageCustomerSection;
